import React from 'react';
import {CreateAppForm, Modal} from '../../components';
import {closeModal} from '../../assets/images/images';

export default function CreateAppModal({open, setOpen}) {
  return (
    <Modal
      show={open}
      onClose={setOpen}
      extraModalClasses="max-w-[528px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
      modalTitle="Create App"
    >
      <CreateAppForm setOpen={setOpen} />
    </Modal>
  );
}
